<template>
  <v-container fluid class="px-4 pa-md-8">
    <v-list flat dense class="">
      <v-list-item-group class>
        <v-list-item class="px-0" @click="back()">
          <v-list-item-icon :disabled="loadingRest" class>
            <v-icon class="headline" color="black">mdi-arrow-left</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0 my-0">
            <v-list-item-title
              class="headline font-weight-bold py-2"
            >{{$t('pedido.totem.carrito.modo.btn.recoger')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-row>
      <v-col cols="12">
        <input-localizacion modo="recoger" @update="addressExists" />
      </v-col>
    </v-row>
    <v-row v-if="loadingRest">
      <v-col class="pb-0" cols="12" sm="6" md="4" v-for="n in 6" :key="n">
        <v-sheet tile>
          <v-skeleton-loader class="mx-auto pa-3" max-width="100%" type="image"></v-skeleton-loader>

          <v-skeleton-loader class="ml-3" type="heading"></v-skeleton-loader>
          <v-skeleton-loader type="actions"></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-for="(restaurant, index) in restaurantesFiltrados"
        :key="index"
      >
        <restaurant-card v-bind:obj="restaurant" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import restaurantCard from "@/components/Pedidos/pedir_restaurantCard.vue";
import inputLocalizacion from "@/components/Pedidos/pedir_inputLocalizacion.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    restaurantCard,
    inputLocalizacion
  },
  data() {
    return {
      loadingAddress: false,
      showRestaurants: false
    };
  },
  mounted() {
    this.setModo();
  },
  computed: {
    ...mapState({
      listadoRestaurantes: state => state.restaurante.listadoRestaurantes,
      loadingRest: state => state.restaurante.loadingRest,
      direcciones: state => state.direcciones.direcciones,
      addressObject: state => state.pedido.addressObject
    }),
    ...mapGetters({
      restaurantesFiltrados: "restaurante/filtradoRestauranteNegocios"
    })
  },
  methods: {
    addressExists(data) {
      this.showRestaurants = data;
    },
    setModo() {
      this.$store.commit("pedido/setModo", "recoger");
    },
    back() {
      this.$store.commit("snackbar/reset");
      this.$router.push({
        path: "/pedir"
      });
    }
  },
  watch: {
    // listadoRestaurantes(newVal, oldVal){
    // 	console.log(newVal, oldVal)
    // }
  },
  mounted() {}
};
</script>

<style>
</style>